import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuButanyerera'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';

const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const muhangaData = {
  title: "REPARTITION DE LA POPULATION DES MENAGES ORDINAIRES PAR COLLINE, ZONE ET COMMUNE",
  province: {
    id: "1",
    name: "BUHUMUZA",
    commune: {
      id: "106",
      name: "MUHANGA",
      total: 222657,
      zones: [
        {
          id: "10601",
          name: "BISHA",
          total: 33076,
          collines: [
            { id: "10601101", name: "TARA", population: 5363 },
            { id: "10601102", name: "GATARE", population: 5171 },
            { id: "10601103", name: "NYABITWE", population: 3419 },
            { id: "10601104", name: "RUBIRIZI", population: 3864 },
            { id: "10601105", name: "BISHURI", population: 4182 },
            { id: "10601106", name: "KABUYE", population: 3956 },
            { id: "10601107", name: "BISHA", population: 2889 },
            { id: "10601108", name: "KAREHE", population: 2851 },
            { id: "10601109", name: "NYAMONDE", population: 1381 }
          ]
        },
        {
          id: "10602",
          name: "GAHETA",
          total: 17971,
          collines: [
            { id: "10602101", name: "GACOKWE", population: 4149 },
            { id: "10602102", name: "MUZUMURE", population: 2759 },
            { id: "10602103", name: "NYABIYOGI", population: 3046 },
            { id: "10602104", name: "BUTANYERERA", population: 2802 },
            { id: "10602105", name: "KARAMA", population: 2583 },
            { id: "10602106", name: "GIPFUVYA", population: 2632 }
          ]
        },
        {
          id: "10603",
          name: "GAHOMBO",
          total: 26564,
          collines: [
            { id: "10603101", name: "RUKAGO", population: 3504 },
            { id: "10603102", name: "GAKURO", population: 1588 },
            { id: "10603103", name: "KARINZI", population: 2573 },
            { id: "10603104", name: "BUSINDE", population: 3459 },
            { id: "10603105", name: "GISHUNZI", population: 1956 },
            { id: "10603106", name: "KIVOGA", population: 2418 },
            { id: "10603107", name: "RUZINGATI", population: 2936 },
            { id: "10603108", name: "BUTEZI", population: 2078 },
            { id: "10603109", name: "KIYANGE", population: 1464 },
            { id: "10603110", name: "MIKONI", population: 1547 },
            { id: "10603111", name: "GAHOMBO", population: 1531 },
            { id: "10603112", name: "KINYONGA", population: 1510 }
          ]
        },
        {
          id: "10604",
          name: "GIKOMERO",
          total: 22441,
          collines: [
            { id: "10604101", name: "GIKOMERO", population: 4760 },
            { id: "10604102", name: "MUSAGARA", population: 4515 },
            { id: "10604103", name: "RUBUNGU", population: 4546 },
            { id: "10604104", name: "RUSAVE", population: 2876 },
            { id: "10604105", name: "KIRAHAMIRA", population: 1734 },
            { id: "10604106", name: "KIGURUKA", population: 3084 },
            { id: "10604107", name: "KAGURUKA", population: 926 }
          ]
        },
        {
          id: "10605",
          name: "MUHANGA",
          total: 23256,
          collines: [
            { id: "10605101", name: "GAHARO", population: 2873 },
            { id: "10605102", name: "MUHANGA", population: 3254 },
            { id: "10605103", name: "KIBIMBA", population: 2296 },
            { id: "10605104", name: "GASHIBUKA", population: 1489 },
            { id: "10605105", name: "MUSAMA", population: 1977 },
            { id: "10605106", name: "NGOMA", population: 1529 },
            { id: "10605107", name: "RUGAMBA", population: 2192 },
            { id: "10605108", name: "MBABA", population: 3581 },
            { id: "10605109", name: "RUSHENZA", population: 1795 },
            { id: "10605110", name: "MWENDO", population: 2270 }
          ]
        },
        {
          id: "10606",
          name: "MIBAZI",
          total: 22750,
          collines: [
            { id: "10606101", name: "NYAMWERA", population: 3350 },
            { id: "10606102", name: "NDAVA", population: 4052 },
            { id: "10606103", name: "CEYEREZI", population: 1977 },
            { id: "10606104", name: "SAKINYINYA", population: 3018 },
            { id: "10606105", name: "MBOGWE", population: 2342 },
            { id: "10606106", name: "GATOZO", population: 1828 },
            { id: "10606107", name: "MIBAZI", population: 1992 },
            { id: "10606108", name: "MASANZE", population: 1531 },
            { id: "10606109", name: "GASENYI", population: 1659 },
            { id: "10606110", name: "KANYUNDO", population: 1001 }
          ]
        },
        {
          id: "10607",
          name: "MUBOGORA",
          total: 32747,
          collines: [
            { id: "10607101", name: "NYARURAMBI", population: 4533 },
            { id: "10607102", name: "MUBOGORA", population: 3316 },
            { id: "10607103", name: "GISARA", population: 4307 },
            { id: "10607104", name: "RUBANGA", population: 4144 },
            { id: "10607105", name: "GITAMO", population: 3311 },
            { id: "10607106", name: "KIVUZO", population: 3004 },
            { id: "10607107", name: "BUSHOKA", population: 2731 },
            { id: "10607108", name: "RUSHUBI", population: 2516 },
            { id: "10607109", name: "GATURA", population: 3000 },
            { id: "10607110", name: "NYAMITANGA", population: 1885 }
          ]
        },
        {
          id: "10608",
          name: "NZEWE",
          total: 22766,
          collines: [
            { id: "10608101", name: "JIMBI", population: 3601 },
            { id: "10608102", name: "MWENENE", population: 2001 },
            { id: "10608103", name: "RUKANU", population: 2880 },
            { id: "10608104", name: "BUTWE", population: 1771 },
            { id: "10608105", name: "SHURUGUMYA", population: 2331 },
            { id: "10608106", name: "BIGUGO", population: 1925 },
            { id: "10608107", name: "GASAVE", population: 1967 },
            { id: "10608108", name: "NZEWE", population: 2929 },
            { id: "10608109", name: "KIVUVUMA", population: 1809 },
            { id: "10608110", name: "KAVUVUMA", population: 1552 }
          ]
        },
        {
          id: "10609",
          name: "RANGO",
          total: 21086,
          collines: [
            { id: "10609101", name: "NYABIBUYE", population: 5503 },
            { id: "10609102", name: "RANGO", population: 4416 },
            { id: "10609103", name: "GITIBU", population: 2763 },
            { id: "10609104", name: "NYARUSANGE", population: 3010 },
            { id: "10609105", name: "RUHINGA", population: 2565 },
            { id: "10609106", name: "GIHORORO", population: 1296 },
            { id: "10609107", name: "RAMA", population: 1533 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageButanyereraMuhanga = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(muhangaData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = muhangaData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info MUHANGA
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {muhangaData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de MUHANGA`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de MUHANGA
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                     
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE DE MUHANGA</TableCell>
                          <TableCell align="right">{muhangaData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de MUHANGA
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de MUHANGA est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de MUHANGA ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageButanyereraMuhanga;